import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SharedService, Tabs } from '../shared.service';
import { TwilioService } from '../twilio.service';
import { ApiService } from '../api.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { localStorageService } from '../localstorage.service';
import { DialerService } from '../dialer.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SubtabsModalComponent } from '../../pages/debt-recovery/debt-recovery-details/Subtabs/subtabs-modal/subtabs-modal.component';
// import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-calling',
  templateUrl: './calling.component.html',
  styleUrl: './calling.component.scss',
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('600ms ease', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('400ms ease', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class CallingComponent implements OnInit, OnChanges {
  extra_data: any;
  @Input() type: string = '';
  alert_data_store: any = [];
  smaller: boolean = false;
  patient_name_innitals: string = '';
  displayPatientName!: string;
  displayPatientNameInnitials!: any;
  constructor(
      public _shared: SharedService,
      public twilio: TwilioService,
      public _api: ApiService,
      private router: Router,
      public dialer: DialerService,
      private modalService: BsModalService
    ) {}
    patient_name = '';
    // Set only when a business user is calling; shown in brackets after the business name.
    business_user_name = '';
    patient_mobile = '';

  ngOnInit() { 
    if(this.type == 'alert'){
      console.log(this.type, 'Type');
    }else{

      console.log(this.twilio.extra_data, 'data');
      this.twilio.opencalling$.subscribe((res) => {
        const data = {
          mobile: this.twilio.extra_data?.device_data?.From?.replace(/^\+?(91|1)/, ''),
        };
        if(res){
          this._api
          .api(data, 'finance/incomming_call_details', 'post')
          .subscribe((res: any) => {
            console.log(res);
            if (!res.is_error && res?.business_name) {
              // A business is calling. If the number belongs to one of its users, their
              // name goes in brackets after the business name.
              this.patient_name = res.business_name;
              this.business_user_name = res?.business_user_name || '';
              this.patient_mobile = res?.patient_mobile;
              this.patient_name_innitals = res.business_name.slice(0, 2).toUpperCase();
            } else if (!res.is_error) {
              this.patient_name =
                (res?.patient_first_name ? res?.patient_first_name : 'Unregistered') + ' ' + (res?.patient_last_name ? res?.patient_last_name : 'Caller');
              this.business_user_name = '';
              this.patient_mobile = res?.patient_mobile;
              this.patient_name_innitals = (res.patient_first_name ? res?.patient_first_name[0] : 'G') + (res?.patient_last_name ? res?.patient_last_name[0] : 'U');
            }else {
              this.patient_name = 'Unregistered Caller';
              this.business_user_name = '';
              this.patient_mobile = this.twilio.extra_data?.device_data?.From?.replace(/^\+?(91|1)/, '');
              console.log('patient_mobile', this.patient_mobile)
              this.patient_name_innitals = 'GU';
            }
          });
        }
      })
      this.twilio.callended$?.subscribe((data: any) => {
        if(data){
          this.twilio.callended$?.next(false);
        }
      });
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['patient_name']) {
      this.displayPatientName = changes['patient_name'].currentValue;
    }
    if (changes['patient_name_innitals']) {
      this.displayPatientNameInnitials = changes['patient_name_innitals'].currentValue;
    }
  }
  rejectCall() {
    this.twilio.rejectCall();
    // setTimeout(() => {
    //   this.hide();
    // }, 1000);
  }
  acceptCall() {
    this.twilio.acceptCall();
  }

  hide() {
    this.twilio.callended$.next(true);
  }
  notificationclose(event: Event, index:any) {
    if (event) {
      event.stopPropagation();
      this.type = ''; 
      this.alert_data_store.splice(index, 1);
    }
  }
  // ToggleMaximize() {
  //   this.dialer.showIcomming = false;
  //   const modelRef = this.modalService.show(SubtabsModalComponent, {
  //     initialState: {
  //       modalType: 'communicationModal',
  //     },
  //     class: 'modal-dialog-centered',
  //     ignoreBackdropClick: true,
  //     backdrop: false,
  //   });
  // }

  Redirect(split_req_id : any, type:any){
    this.router.navigate(['/app/debt-recovery/details/' + this._shared.encodeId(split_req_id)], { queryParams: { type: type }});
  }
  Smaller(){
    this.smaller = true;
  }
}
interface modal_data {
  incomingCall?: any;
  device?: any;
  device_data?: any;
  call_id?: any;
}
